import React from 'react';
import PropTypes from 'prop-types';
import {getDataAttribute} from 'epic-common/src/browser';

export default class SectionNav extends React.Component {
    static propTypes = {
        loadingSection: PropTypes.number,
        sections: PropTypes.array,
        initLoad: PropTypes.bool
    };

    moveTo = (e) => {
        e.preventDefault();
        const sectionNum = +getDataAttribute(e.currentTarget, 'section');
        if (sectionNum) {
            $.fn.fullpage.moveTo(sectionNum);
        }
    };

    prev = () => {
        $.fn.fullpage.moveSectionUp();
    };

    next = () => {
        $.fn.fullpage.moveSectionDown();
    };

    render() {
        const pages = this.props.sections || [];
        const sectionsLength = pages.length;

        //check for reactions section
        const lastSection = sectionsLength;
        let loadingSection = this.props.loadingSection || 1;
        if (loadingSection) {
            loadingSection--; //convert to index
        }
        const scrollNavStyle = this.props.initLoad ? '' : 'notLoaded';
        const arrowColor = loadingSection === 1 || loadingSection === 2 || loadingSection === 3 || loadingSection === 6 ? 'black' : 'white';
        return (
            <div id="fullPageScrollNav" className={scrollNavStyle}>
                <ul>
                    <li role="presentation" className={`arrow prev ${arrowColor} ${loadingSection === 0 ? 'not-visible' : ''}`} onClick={this.prev}>
                        <i className="icon-prevArrow" />
                    </li>
                    {
                        pages.map((page, i) => {
                            let active = loadingSection === i ? 'white active' : 'white';
                            if (loadingSection === 1 || loadingSection === 2 || loadingSection === 3 || loadingSection === 6) {
                                active = loadingSection === i ? 'black active' : 'black';
                            }
                            return (
                                <li key={`section-nav-${page.title}`} className={active}>
                                    <a href={`home#${page.anchor}` || '#'} data-section={i + 1} onClick={this.moveTo}>
                                        <span>{page.title}</span>
                                    </a>
                                </li>
                            );
                        })
                    }
                    <li role="presentation" className={`arrow next ${arrowColor} ${loadingSection === lastSection ? 'not-visible' : ''}`} onClick={this.next}>
                        <i className="icon-nextArrow" />
                    </li>
                </ul>
            </div>
        );
    }
}
